














import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import i18n from '@/webcomponents/header/i18n';
import ChildComponentMixin from '../../common/ts/child-component/ChildComponentMixin';

const LanguageSwitcherItemProps = Vue.extend({
  props: {
    linkRef: String,
    isActive: Boolean,
    labelDesktop: String,
    labelMobile: String,
  },
});

@Component({
  i18n,
})
export default class LanguageSwitcherItem extends mixins(LanguageSwitcherItemProps, ChildComponentMixin) {
  created () {
    this.initChildComponentMixin(
      'LanguageSwitcherItem',
    );
  }

  onItemClick (): void {
    if (this.linkRef) {
      const link = this.linkRef;
      const label = this.labelDesktop;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Language Switcher', label, link);
    }
  }
}
